export default "__VITE_ASSET__DTsuc_W4__"